export default "__VITE_PUBLIC_ASSET__ed2f71bb__"